import { VueModule } from '@Foundation/utilities';
import BrandSlider from './brand-slider.vue';

export default VueModule({
  components: {
    BrandSlider,
  }
});
